export function basename(path: string): string {
    return path.split(/[\\/]/).pop() || '';
}

export function fileExtension(path: string): string {
    const filename = basename(path);
    const pos = filename.lastIndexOf('.');
    if (pos < 0 || pos === filename.length - 1) {
        return '';
    }
    return filename.substring(pos);
}

export function fileWithoutExtension(path: string): string {
    const filename = basename(path);
    const pos = filename.lastIndexOf('.');
    if (pos < 0) {
        return filename;
    }
    return filename.substring(0, pos);
}
